<template>
  <div>
    <div class="h-toolbarBg">
    </div>
    <div class="h100-80 h-scroll">
      <ejs-grid :dataSource="devData" ref="grid">
        <e-columns>
          <!-- <e-column type="checkbox" width="50" textAlign="center"></e-column> -->
          <e-column field="id" :visible="false"></e-column>
          <e-column field="neId" :visible="false"></e-column>
          <!-- <e-column field="equipmentName" :headerText="$t('Topo.devName')" width="120" textAlign="Center"></e-column> -->
          <!-- <e-column field="typeName" :headerText="$t('Topo.devType')" width="120" textAlign="Center"></e-column> -->
          <e-column field="esn" :headerText="$t('Security.Lic.esn')" width="120" textAlign="Center"></e-column>
          <!-- <e-column field="displaySoftwareVersion" :headerText="$t('Topo.devSoftVersion')" width="120" textAlign="Center"></e-column> -->
          <e-column field="status" :headerText="$t('Security.Lic.uploadStatus')" width="120" textAlign="Center"  :formatter='uploadStatusFormat'></e-column>
          <e-column field="uploadTime" :headerText="$t('Security.Lic.uploadTime')" width="120" textAlign="Center"  :formatter='uploadDate'></e-column>
          <e-column field="installTime" :headerText="$t('Security.Lic.installTime')" width="120" textAlign="Center"  :formatter='installDate'></e-column>
          <e-column field="activeTime" :headerText="$t('Security.Lic.activeTime')" width="120" textAlign="Center"  :formatter='actDate'></e-column>
          <e-column field="isHistory" :headerText="$t('Security.Lic.currentStatus')" width="120" textAlign="Center"  :formatter='showIsHistory'></e-column>

        </e-columns>
      </ejs-grid>
    </div>

  </div>
</template>

<script>
export default {
  name: "LicHistory",
  data() {
    return {
      devData: [],

      items: []
    }
  },
  methods: {
    findDevLicenseHistory(neId) {
      const url = '/lte/ems/license/findHistoryLicenseInfo';
      let That = this;
      this.$axios.get(url, { params: { neId: neId }}).then(response => {
        let result = response.data;

        That.devData = result;
      })


      
    },
    uploadStatusFormat(grids, data) {
      if(data.status == null){
        return `${this.$t('Security.Lic.uploadStatus_unupload')}`;
      }else if(data.status == 1){
         return `${this.$t('Security.Lic.uploadStatus_uploaded')}`;
      }else if(data.status == 2){
         return `${this.$t('Security.Lic.installStatus')}`;
      }else if(data.status == 3){
        return `${this.$t('Security.Lic.activeStatus_activated')}`;
      }
    },
    showIsHistory(grids, data){
      if(data.ishistory==1){
        return `${this.$t('Security.Lic.loseEfficacy')}`;
      }else if(data.ishistory==0){
        return `${this.$t('Security.Lic.normal')}`;

      }
    },
    actDate(grids, data) {
      if(!!data.activeTime&&data.activeTime!=null){
        return this.formatDateTime(data.activeTime);
      }else{
        return '';
      }
    },
    uploadDate(grids, data) {
        if(!!data.uploadTime&&data.uploadTime!=null){
          return this.formatDateTime(data.uploadTime);
        }else{
          return '';
        }
    },
    installDate(grids, data) {
        if(!!data.installTime&&data.installTime!=null){
          return this.formatDateTime(data.installTime);
        }else{
          return '';
        }
    },
    formatDateTime(timeStamp) {
        var date = new Date();
        date.setTime(timeStamp);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
    },
  }
}
</script>
<style scoped>
  .license_box{
    width: 70%;
    margin: 10px 15%;
  }
</style>
